import { BrowserRouter, Routes, Route } from "react-router-dom";

// WEBSITE
import Home from "./pages/Home";
import About from "./pages/About";
import NewsPage from "./pages/NewsPage";
import Notice from "./pages/Notice";
import EventPage from "./pages/EventPage";
import Contact from "./pages/Contact";
import LifePage from "./pages/LifePage";
import Gallery from "./pages/Gallery";
import GalleryDetail from "./pages/GalleryDetail";
import Documents from "./pages/Documents";
import ScrollToTop from "./components/ScrollToTop";
import Admission from "./pages/Admission";
import Academics from "./pages/Academics";
import CbseDocuments from "./pages/CbseDocuments";
import StudentTc from "./pages/StudentTc";
import StudentTcDetails from "./pages/StudentTcDetails";
import StudentTcSession from "./pages/StudentTcSession";
import VirtualTour from "./pages/VirtualTour";
import HomeVirtualTour from "./components/HomeVirtualTour";
import Sports from "./pages/Sports";
import SportDetails from "./pages/SportDetails";
import Clubs from "./pages/Clubs";
import Archive from "./pages/Archive";
import OnlineRegistration from "./pages/OnlineRegistration";
import Holidays from "./pages/Holidays";
import ClassMonitor from "./pages/ClassMonitor";
import StudentCouncil from "./pages/StudentCouncil";
import SchoolHouse from "./pages/SchoolHouse";
import SingleHouse from "./pages/SingleHouse";
import Assembly from "./pages/Assembly";
import SocialCalendar from "./pages/SocialCalendar";
import Transport from "./pages/Transport";
import TransportDetails from "./pages/TransportDetails";
import Alumni from "./pages/Alumni";
import AlumniLogin from "./pages/AlumniLogin";
import AlumniComment from "./pages/AlumniComment";

// ADMIN LOGIN
import AdminLogin from "./pages/AdminLogin";

// ADMIN PAGES
import AdminDashboard from "./pages/AdminDashboard";
import AdminNews from "./admin/AdminNews";
import AdminNotice from "./admin/AdminNotice";
import AdminEvent from "./admin/AdminEvent";
import AdminBirthday from "./admin/AdminBirthday";
import AdminSlider from "./admin/AdminSlider";
import AdminAcademics from "./admin/AdminAcademics";
import AdminGalleryAwards from "./admin/AdminGalleryAwards";
import AdminStudentWork from "./admin/AdminStudentWork";
import AdminChangePassword from "./admin/AdminChangePassword";
import AdminGalleryAlbum from "./admin/AdminGalleryAlbum";
import AdminDocument from "./admin/AdminDocument";
import AdminCbseDocument from "./admin/AdminCbseDocument";
import AdminStudentTc from "./admin/AdminStudentTc";
import AdminTour from "./admin/AdminTour";
import AdminHotspot from "./admin/AdminHotspot";
import AdminOnlineRegistration from "./admin/AdminOnlineRegistration";
import AdminHolidays from "./admin/AdminHolidays";
import AdminClassMonitor from "./admin/AdminClassMonitor";
import AdminStudentCouncil from "./admin/AdminStudentCouncil";
import AdminSchoolHouse from "./admin/AdminSchoolHouse";
import AdminAlumni from "./admin/AdminAlumni";
import AdminAlumniComments from "./admin/AdminAlumniComments";

// PROTECTED ROUTE
import ProtectedRoute from "./components/ProtectedRoute";


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>

        {/* ================= WEBSITE ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/archives" element={<Archive />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/notices/:id" element={<Notice />} />
        <Route path="/events" element={<EventPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/life" element={<LifePage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:id" element={<GalleryDetail />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/admission" element={<Admission />} />
        <Route
          path="/academics"
          element={<Academics />}
        >

          <Route
            path="holidays"
            element={<Holidays />}
          />

          <Route
            path="class-monitor"
            element={<ClassMonitor />}
          />

          <Route
            path="student-council"
            element={<StudentCouncil />}
          />

          <Route
            path="school-house"
            element={<SchoolHouse />}
          />

          <Route
            path="school-house/:houseName"
            element={<SingleHouse />}
          />

        </Route>
        <Route path="/cbse-documents" element={<CbseDocuments />} />
        <Route path="/student-tc" element={<StudentTc />} />
        <Route path="/student-tc/session/:id" element={<StudentTcSession />} />
        <Route path="/student-tc/class/:id" element={<StudentTcDetails />} />
        <Route path="/virtual-tour" element={<VirtualTour />} />
        <Route path="/home-virtual-tour" element={<HomeVirtualTour />} />
        <Route path="/sports" element={<Sports />} />
        <Route path="/sports/:slug" element={<SportDetails />} />
        <Route path="/clubs" element={<Clubs />} />
        <Route path="/online-registration" element={<OnlineRegistration />} />
        <Route path="/holiday" element={<Holidays />} />
        <Route path="/class-monitor" element={<ClassMonitor />} />
        <Route path="/student-council" element={<StudentCouncil />} />
        <Route path="/school-house" element={<SchoolHouse />} />
        <Route path="/school-house/:houseName" element={<SingleHouse />} />
        <Route path="/assembly" element={<Assembly />} />
        <Route path="/calendar" element={<SocialCalendar />} />
        <Route path="/transport" element={<Transport />} />
        <Route path="/transport/:id" element={<TransportDetails />} />
        <Route path="/alumni" element={<Alumni />} />
        <Route path="/alumni-login" element={<AlumniLogin />} />
        <Route path="/alumni-comments" element={<AlumniComment />} />

        {/* ================= ADMIN ================= */}

        {/* LOGIN */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* PROTECTED ROUTES */}

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/notice"
          element={
            <ProtectedRoute>
              <AdminNotice />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/event"
          element={
            <ProtectedRoute>
              <AdminEvent />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/birthday"
          element={
            <ProtectedRoute>
              <AdminBirthday />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/slider"
          element={
            <ProtectedRoute>
              <AdminSlider />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/academics"
          element={
            <ProtectedRoute>
              <AdminAcademics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/galleryAwards"
          element={
            <ProtectedRoute>
              <AdminGalleryAwards />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/student-work"
          element={
            <ProtectedRoute>
              <AdminStudentWork />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/news"
          element={
            <ProtectedRoute>
              <AdminNews />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/password"
          element={
            <ProtectedRoute>
              <AdminChangePassword />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/gallery-album"
          element={
            <ProtectedRoute>
              <AdminGalleryAlbum />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/uploadDocuments"
          element={
            <ProtectedRoute>
              <AdminDocument />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/cbse"
          element={
            <ProtectedRoute>
              <AdminCbseDocument />
            </ProtectedRoute>}
        />

        <Route
          path="/admin/adminstudent-tc"
          element={
            <ProtectedRoute>
              <AdminStudentTc />
            </ProtectedRoute>}
        />

        <Route
          path="/admin/admin-tour"
          element={
            <ProtectedRoute>
              <AdminTour />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-hotspot"
          element={
            <ProtectedRoute>
              <AdminHotspot />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-online"
          element={
            <ProtectedRoute>
              <AdminOnlineRegistration />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-holiday"
          element={
            <ProtectedRoute>
              <AdminHolidays />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-class"
          element={
            <ProtectedRoute>
              <AdminClassMonitor />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-studentcouncil"
          element={
            <ProtectedRoute>
              <AdminStudentCouncil />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/admin-house"
          element={
            <ProtectedRoute>
              <AdminSchoolHouse />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/alumni"
          element={
            <ProtectedRoute>
              <AdminAlumni />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/alumni-comments"
          element={
            <ProtectedRoute>
              <AdminAlumniComments />
            </ProtectedRoute>
          }
        />


        {/* ================= 404 ================= */}
        <Route path="*" element={<h2>Page Not Found</h2>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;